export default {
  zh: {
    netVersion: '.NET版：',
    oldVersion: 'OS X 10.10-10.11 支持的版本',
    stableVersion: '历史版：',
    betaVersion: '尝鲜版：'
  },
  en: {
    netVersion: '.NET version: ',
    oldVersion: 'OS X 10.10-10.11 supported version',
    stableVersion: 'Legacy versions: ',
    betaVersion: 'Beta: '
  }
}



// WEBPACK FOOTER //
// ./src/components/download/downloadOtherVersion/lang.js